<template>
  <div class="container">
    <div class="row">

      <div class="col-12 text-left mb-3">
        <button @click="sendNotificationMessageForUser" class="btn btn-primary rounded-pill">
          ارسال پیام اطلاعیه به
          کاربر
        </button>
        <button @click="redirectToSiteForm" class="btn btn-primary mx-1 rounded-pill">
          مشاهده فرم در سایت
        </button>
      </div>

      <div class="col-6">
        <h4>فرم:
          {{ form.name }}
        </h4>
      </div>

      <div class="col-6">
        <h4>پاسخ نامه:
          {{ user.name }} {{ user.last_name }}
          <router-link target="_blank" class="p"
                       :to="{ name: 'UpdateUser', params: { id: user.id } }">
            (پروفایل)
          </router-link>
        </h4>
      </div>


    </div>

    <div class="col-12">
      <table class="table table-hover table-striped table-bordered table-responsive-md table-responsive-sm">
        <thead>
        <tr>
          <th scope="col">شناسه</th>
          <th scope="col">سوال</th>
          <th scope="col">پاسخ</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(answer,index) in answers">
          <th>{{ answer.id }}</th>
          <td>{{ formQuestion(form, answer.form_item_id)['title'] }}</td>
          <td >
            <template v-if="formAnswer(form, answer.form_item_id, answer).type == 'category_input'">
              <form-category-answer :answer="formAnswer(form, answer.form_item_id, answer)" />
            </template>
            <template v-else-if="formAnswer(form, answer.form_item_id, answer).type == 'choose_product_input'">
              <form-choose-product-input-answer :answer="formAnswer(form, answer.form_item_id, answer)" />
            </template>
            <template v-else-if="formAnswer(form, answer.form_item_id, answer).type == 'choose_multiple_product_input'">
              <form-choose-multiple-product-input-answer :answer="formAnswer(form, answer.form_item_id, answer)" />
            </template>
            <template v-else-if="formAnswer(form, answer.form_item_id, answer).type == 'create_shopping_cart_input'">
              <span dir="ltr">{{ dateConverter(answer.created_at,'/',true) }}</span>
            </template>
            <template v-else>
              <span v-html="formAnswerManager(formAnswer(form, answer.form_item_id, answer))"></span>
            </template>

          </td>
          <td>

            <b-icon-pen v-b-modal="`edit-answer-${answer.id}`"
                        v-if="formQuestion(form, answer.form_item_id)?.config?.only_admin_edit == true && isAdmin"/>
            <b-modal :id="`edit-answer-${answer.id}`" hide-footer>
              <form @submit.prevent="submitAnswerForm(answer,index)">
                <div class="text-right" dir="rtl">
                  <label for="">
                    ویرایش پاسخ:
                    {{ formQuestion(form, answer.form_item_id)['title'] }}
                  </label>
                  <input class="form-control" type="text" v-model="answers[index].answer">
                </div>
                <div class="col-12 my-2">
                  <div class="row text-center">
                    <button class="btn col-12 btn-primary">ثبت</button>
                  </div>
                </div>

              </form>
            </b-modal>

          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <form @submit.prevent="sendFormDescription">

      <div class="form-group">
        <label>وضعیت فرم</label>
        <select :disabled="!isAdmin" class="custom-select" v-model="formFillDescription.status">
          <option v-for="(item,index) in form_fill_status" :value="index">{{ item }}</option>
        </select>
      </div>

      <div class="form-group" v-if="getFormType(form.form_questions) == 'step'">
        <label>مرحله فرم</label>
        <select :disabled="!isAdmin" class="custom-select" v-model="formFillDescription.step">
          <option v-for="(item,index) in extractFormSteps(form.form_questions)" :value="index">{{ item.title }}</option>
        </select>
      </div>


      <div class="form-group">
        <label for="exampleFormControlTextarea1">توضیحات</label>
        <textarea minlength="1" v-model="formFillDescription.description" :disabled="!isAdmin" class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"></textarea>
      </div>

      <div class="col-12 text-center">
        <button type="submit" class="btn btn-primary px-5" v-if="isAdmin">ثبت</button>
      </div>

    </form>

    <hr>

    <div class="border shadow p-3 rounded" v-if="isAdmin">
      <h1>چت با کاربر</h1>

      <chat-form v-if="formFillChatSlug() == false && isAdmin" class="form-answer-chat-form"
                 :submit-function="startNewChatWrapper"/>
      <div class="" v-if="formFillChatSlug() != false">
        <m-a :href="formFillChatSlug()" target="_blank">
          <button class="btn btn-primary rounded-pill">مشاهده چت</button>
        </m-a>
      </div>
    </div>


  </div>
</template>

<script>
import {
  convertCategoryInputValueToNames,
  extractFormSteps,
  form_fill_status,
  formAnswer,
  formAnswerManager,
  formQuestion,
  getFormType
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Form";
import {mapGetters} from "vuex";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import ChatForm from "@/plugin/components/dashboard/Chat/ChatForm.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import FormCategoryAnswer from "./FormCategoryAnswer.vue";
import FormChooseProductInputAnswer from "./FormChooseProductInputAnswer.vue";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import FormChooseMultipleProductInputAnswer from "./FormChooseMultipleProductInputAnswer.vue";


export default {
  name: "FormAnswer",
  components: {FormChooseMultipleProductInputAnswer, FormChooseProductInputAnswer, FormCategoryAnswer, ChatForm},
  data() {
    return {
      form_fill_status,
      answers: {},
      form: {},
      user: {},
      formFillMeta: {},
      formFillDescription: {
        description: null,
        step: null,
        status: null,
      },
      categoryAnswer:''
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: "User/isAdmin",
      adminProfile: "User/getProfile"
    }),
    formFillId() {
      return this.$route.params.form_fill
    },
  },
  methods: {
    dateConverter,
    formAnswerManager,
    formAnswer,
    formQuestion,
    setFormFillDescription(baseData) {
      let formFill = baseData.formFill
      let metas = baseData.formFillMeta

      metas.forEach(item => {
        if (item.name == 'form-fill-description') {
          this.formFillDescription.description = item.value
        }
      })

      this.formFillDescription.status = formFill.status
      this.formFillDescription.step = baseData.form_step
    },
    getAnswerData() {
      let form = {
        user_id: this.$route.params.user,
        form_fill_id: this.$route.params.form_fill,
      }
      let req = this.$store.dispatch('Form/getFormAnswer', form)
      req.then(res => {
        let baseData = res.data.data

        this.answers = baseData.answers
        this.form = baseData.form
        this.user = baseData.user
        this.formFill = baseData.formFill
        this.formFillMeta = baseData.formFillMeta
        this.setFormFillDescription(baseData)
      })
    },
    sendFormDescription() {
      let form = Object.assign({}, this.formFillDescription)
      form['id'] = this.$route.params.form_fill
      this.$store.dispatch("Form/setDescriptionOfFormFill", form).then(res => {
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.', 'success')
      })
    },
    storeChatLink(chatLink) {
      let form = {
        "name": 'form_fill_chat_link',
        "value": chatLink,
        "metable_type": 'formFill',
        "metable_id": this.formFillId,
        "type": 0,
        "overwrite_preview_value": 0,
      }
      this.$store.dispatch('Meta/createMeta', form).then(res => {
        this.getAnswerData()
      })
    },
    startNewChatWrapper(form) {
      let adminChatToken = this.adminProfile.chat_token
      let userChatToken = this.user.chat_token

      form.withoutState = true

      form.users = [...new Set([adminChatToken, userChatToken])]


      this.$store.dispatch('Chat/startNewChat', form).then(res => {
        let data = res.data.data.data
        let slug = data.slug

        this.storeChatLink(slug)

        let routeData = this.$router.resolve({name: 'SingleChat', params: {slug: slug}});
        window.open(routeData.href, '_blank');

      })
    },
    formFillChatSlug() {
      let result = false
      if (Object.keys(this.formFillMeta).length == 0) {
        return result
      }
      this.formFillMeta.forEach(item => {
        if (item.name == "form_fill_chat_link") {
          result = this.$router.resolve({name: 'SingleChat', params: {slug: item.value}}).href
        }
      })
      return result
    },
    getFormType,
    extractFormSteps,
    submitAnswerForm(answerObject, answerIndex) {


      let form = {
        form_fill_item_value: this.answers[answerIndex].answer,
        form_fill_item_id: answerObject.id,
        form_fill: this.$route.params.form_fill
      }

      this.$store.dispatch('Form/updateFormAnswerFromAdmin', form).then(res => {
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
      })

    },
    sendNotificationMessageForUser() {
      if (confirm('آیا از ارسال اطلاعیه اطمینان دارید؟')) {
        let form = {
          formFill: this.$route.params.form_fill,
        }
        this.$store.dispatch('Form/sendNotificationSmsMessage', form).then(res => {
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        })
      }
    },
    redirectToSiteForm() {
      let url = this.$router.resolve({
        name: 'FormAnswer',
        params: {user: this.$route.params.user, form_fill: this.$route.params.form_fill}
      })['href']
      window.open(`${findAttributeOnSiteInfo('site_link')}${url}`, '_blank');
    }
  },
  mounted() {
    this.getAnswerData()


  }
}
</script>


<style scoped>
.form-answer-chat-form ::v-deep .chat-form-tags,
.form-answer-chat-form ::v-deep .chat-form-users,
.form-answer-chat-form ::v-deep .chat-form-group,
.form-answer-chat-form ::v-deep .chat-form-files,
.form-answer-chat-form ::v-deep .chat-form-categories {
  display: none;
}
</style>